// This icon file is generated automatically.
// tslint:disable
var AddOutlined = { "name": "add", "theme": "outlined", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M480 480V288q0-14 9-23t23-9 23 9 9 23v192h192q14 0 23 9t9 23-9 23-23 9H544v192q0 14-9 23t-23 9-23-9-9-23V544H288q-14 0-23-9t-9-23 9-23 23-9h192z" } }] } };
export default AddOutlined;
